// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"71e1518e4e","253":"ad378e1904","619":"2b5c5d46cc"}[chunkId] + ".js";
};